<div  *ngIf="!mobileOS()" class="cursor"></div>
